module.exports = __webpack_public_path__ + "img/payout-config.784b7fe9.svg";